import { render } from "./CouponManagement.vue?vue&type=template&id=3502fca9&scoped=true&ts=true"
import script from "./CouponManagement.vue?vue&type=script&lang=ts"
export * from "./CouponManagement.vue?vue&type=script&lang=ts"

import "./CouponManagement.vue?vue&type=style&index=0&id=3502fca9&lang=scss&scoped=true"

import exportComponent from "/opt/pptcopilot/app/ppt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3502fca9"]])

export default __exports__